





















































































import Vue from 'vue'
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'

import { SearchOption } from '@/interfaces/search-option'

@Component
export default class AppTextSearch extends Vue {
  @Prop({ type: Object as () => SearchOption }) readonly value!: SearchOption
  @Prop(String) readonly label!: string
  @Prop({ type: String }) readonly placeholder!: string
  @Prop({ type: Boolean, default: false }) readonly required!: boolean
  @Prop({ type: [Number, String], default: '289' }) readonly width!: number | string
  @Prop({ type: [Number, String], default: 36 }) readonly height!: number | string
  @Prop({ type: String }) readonly confirm!: string
  @Prop({ type: Boolean, default: false }) readonly autofocus!: boolean
  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean
  @Prop({ type: Array }) readonly items!: SearchOption[]
  @Prop({ type: Boolean, default: false }) readonly showSearchBtn!: boolean
  @Prop({ type: String, default: '' }) readonly className!: string
  @Prop({ type: String, default: '' }) readonly inlineLabel!: string
  @Prop({ type: Boolean, default: false }) readonly dense!: boolean

  model: SearchOption = {
    id: undefined,
    name: ''
  }
  viewModel = ''
  loading = false

  showPWD = false

  delay: any = null

  listPosConf = {
    top: 0,
    left: 0,
    width: 0
  }

  showList = false

  rules = {
    required: (value: string) => {
      return !!value || 'Required.'
    },
    text: () => true
  }

  selectedIdx = -1

  get options () {
    return [{ id: undefined, name: '-' }, ...this.items]
  }

  mounted () {
    if (this.value && !this.$R.isEmpty(this.value)) {
      this.onValueChanged(this.value)
    }
    this.onResize()
  }

  onResize () {
    const inputDom = this.$refs.searchOrInput as Vue & {
      getBoundingClientRect: () => any;
    }

    const input = inputDom.getBoundingClientRect()
    this.listPosConf.width = input.width
    const optionsHeight = Math.min((this.options.length + 1) * 48 + 16, 350)

    if (this.options.length > 0 && input.y > window.innerHeight - optionsHeight) {
      this.listPosConf.top = optionsHeight > 350
        ? window.innerHeight - 350
        : window.innerHeight - optionsHeight
      this.listPosConf.left = 2 * input.width + input.x > window.innerWidth
        ? input.x - input.width - 10
        : input.x + input.width + 10
    } else {
      this.listPosConf.top = input.y + (this.dense ? 30 : 58)
      this.listPosConf.left = input.x
    }
  }

  @Watch('items', {
    deep: true
  })
  onItemsChanged () {
    this.onResize()
  }

  @Watch('value')
  onValueChanged (val: SearchOption) {
    this.model = val || {
      id: undefined,
      name: ''
    }
    this.viewModel = val ? val.name : ''
  }

  @Watch('viewModel')
  onSearchChanged (val: string) {
    if (this.items.length === 2 && this.items[1].name === val) {
      return
    }
    this.delay = setTimeout(() => {
      this.searchHandler()
    }, 500)
  }

  focusHandler () {
    this.onResize()
    this.showList = true
  }

  blurHandler () {
    if (this.items.length === 0) {
      this.model = {
        id: undefined,
        name: ''
      }
      this.viewModel = ''
    }
    setTimeout(() => {
      const { viewModel } = this
      this.showList = false
      if (viewModel) {
        const matchItem = this.items.find(item => item.name.toLowerCase() === viewModel.toLowerCase())
        if (matchItem) {
          this.model = matchItem
        } else {
          const res = this.items.find(item => item.name.toLowerCase().indexOf(viewModel.toLowerCase()) !== -1)
          if (res) {
            this.model = res
            this.viewModel = res.name
          }
        }
      }
      this.valueChangedHandler()
    }, 300)
  }

  keyDownHandler (e: KeyboardEvent) {
    const selectedIdx = !isNaN(this.selectedIdx)
      ? this.selectedIdx
      : -1
    switch (e.key) {
      case 'ArrowUp' :
        this.selectedIdx = selectedIdx - 1 < 0 ? 0 : selectedIdx - 1
        break
      case 'ArrowDown' :
        this.selectedIdx = selectedIdx + 1 > this.items.length - 1 ? this.items.length - 1 : selectedIdx + 1
        break
      case 'Enter' :
        this.selectHandler(selectedIdx)
        break
      case 'Backspace' :
        this.showList = true
    }
  }

  @Emit('find')
  findhHandler () {
    return {
      name: this.viewModel,
      type: 'find'
    }
  }

  @Emit('query')
  searchHandler () {
    return this.viewModel
  }

  @Emit('input')
  valueChangedHandler () {
    return this.model
  }

  @Emit('selected')
  selectHandler (idx: number) {
    if (idx === 0) {
      this.model = {
        id: undefined,
        name: ''
      }
      this.viewModel = ''
    } else {
      const selected = this.items[idx - 1]
      if (selected) {
        this.model = selected
        this.viewModel = selected.name
      }
      this.showList = false
    }
    this.valueChangedHandler()
  }

  clearModel () {
    if (this.disabled) {
      return
    }
    this.selectHandler(0)
  }
}
